export default __webpack_public_path__ + "static/media/craon30.5edbcd11.jpg";